import Page from "../../features/Industrias.feature/Page";



export default function Industrias() {
    return (<Page/>);
  }